import { render } from "./inbox-header.vue?vue&type=template&id=72c41484"
import script from "./inbox-header.vue?vue&type=script&lang=js"
export * from "./inbox-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__